import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { computeRoutesDistance } from "../../../actions/googleMaps";
import { useGoogleMapsApiKey } from "../googleMaps/googleMapsKeyContext";

const useGoogleRoute = (idArt) => {
  const dispatch = useDispatch();
  const { apiKey } = useGoogleMapsApiKey(idArt);

  const getDistanceBetweenPoints = useCallback(
    async (origin, destination) => {
      try {
        const result = await dispatch(computeRoutesDistance(apiKey, origin, destination));
        const data = result?.value?.data;
        if (Number.isFinite(data?.distanceMeters)) return data;
      } catch {
        // La clave resuelta falló. No se reintenta con otra.
      }

      return {
        distanceMeters: null,
        durationMillis: null,
        route: null,
      };
    },
    [apiKey, dispatch],
  );

  return { getDistanceBetweenPoints };
};

export default useGoogleRoute;
